import { api } from './base';

import { MutationArg } from 'v2/types';
import { MasterKeyModel } from 'v2/types/MasterKeyModel';
import { SWRKeyValue } from 'v2/types/swr';

export const masterKeyService = {
  getMasterKeys(): Promise<MasterKeyModel[]> {
    return api.get('admin/master-key').json();
  },

  createMasterKey(_key: string, { arg }: MutationArg<Pick<MasterKeyModel, 'roles' | 'name'>>): Promise<MasterKeyModel> {
    return api.post('admin/master-key', { json: arg }).json();
  },

  updateMasterKey(
    [_key, keyId]: SWRKeyValue,
    { arg }: MutationArg<Pick<MasterKeyModel, 'roles' | 'name'>>
  ): Promise<MasterKeyModel> {
    return api.put(`admin/master-key/${keyId}`, { json: arg }).json();
  },

  deleteMasterKey([_key, keyId]: SWRKeyValue): Promise<void> {
    return api.delete(`admin/master-key/${keyId}`).json();
  },
};
